var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { Row } from "react-bootstrap";
import styled from "styled-components";
import { connect } from "react-redux";
import { get } from "lodash";
import { FormattedMessage } from "@irati/utils/lang";
import getId from "@irati/utils/id";
import Slider from "@irati/ui/src/Slider";
import { minWidthMedia, DESKTOP, TABLET } from "@irati/ui/src/global/media";
import padding from "@irati/ui/src/global/padding";
import { H3 } from "@irati/ui/src/Headings";
import { ButtonRouterLink } from "@irati/ui/src/Link";
import DisablePointerEventsOnScroll from "@irati/ui/src/Feed/DisablePointerEventsOnScroll";
import Icon, { IconTypes } from "@irati/ui/src/Icon";
import Flex from "@irati/ui/src/Flex";
import CustomTile from "../CustomReward/Tile";
import RewardTile from "../Tile";
var TileContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 0 5px;\n  ", "\n"], ["\n  padding: 0 5px;\n  ",
    "\n"])), minWidthMedia.tablet(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding: 0 ", ";\n  "], ["\n    padding: 0 ", ";\n  "])), padding.tiny));
var ButtonsContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  justify-content: flex-end;\n"], ["\n  display: flex;\n  justify-content: flex-end;\n"])));
var BodyRow = styled(Row)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-bottom: ", ";\n"], ["\n  margin-bottom: ", ";\n"])), padding.medium);
var FeedSlider = /** @class */ (function (_super) {
    __extends(FeedSlider, _super);
    function FeedSlider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FeedSlider.prototype.render = function () {
        var _this = this;
        var _a = this.props, id = _a.id, isFirst = _a.isFirst, title = _a.title, data = _a.data, isMobile = _a.isMobile;
        var moreThanOneFeedItem = data.length > 1;
        var sliderSettings = {
            centerMode: moreThanOneFeedItem && isMobile,
            infinite: moreThanOneFeedItem && isMobile,
            draggable: moreThanOneFeedItem && isMobile,
            centerPadding: "30px",
            responsive: [
                { breakpoint: TABLET, settings: { slidesToShow: 1, slidesToScroll: 1 } },
                { breakpoint: DESKTOP, settings: { slidesToShow: 2, slidesToScroll: 2 } }
            ]
        };
        return (data.length === 0 ? null : (React.createElement(React.Fragment, null,
            React.createElement(Flex, { justifyContent: "space-between", alignItems: "center", marginTop: 2, marginBottom: 2 },
                React.createElement(H3, null, title),
                React.createElement(ButtonsContainer, null,
                    React.createElement(ButtonRouterLink, { tertiary: true, cta: true, id: getId("link", this.props), to: "/reward/all" },
                        React.createElement(Flex, { alignItems: "center" },
                            React.createElement(FormattedMessage, { id: "reward.homepage.links.allrewards" }),
                            React.createElement(Icon, { icon: IconTypes.arrowRight, marginLeft: true }))))),
            React.createElement(BodyRow, null,
                React.createElement(DisablePointerEventsOnScroll, null,
                    React.createElement(Slider, { id: id, className: "feed-slider", settings: sliderSettings },
                        isFirst && React.createElement(TileContainer, null,
                            React.createElement(CustomTile, null)),
                        data.map(function (reward, index) { return (React.createElement(TileContainer, { key: reward.uuid },
                            React.createElement(RewardTile, { id: getId("reward-" + index, _this.props), reward: reward }))); })))))));
    };
    return FeedSlider;
}(Component));
var mapStateToProps = function (_a) {
    var mq = _a.mq;
    return {
        isMobile: get(mq, "lessThan.medium", false)
    };
};
export default connect(mapStateToProps)(FeedSlider);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
